export default __webpack_public_path__ + "static/media/bg4.00100f0e.png";